const ClientId = {
  PouchId: 'POUCH_ID',
  VenueDashboard: 'VENUE_DASHBOARD',
  Connector: 'CONNECTOR',
};

export default Object.freeze(ClientId);
